// extracted by mini-css-extract-plugin
export default {"body":"recommended_body__6NpWU","content":"recommended_content__EtfJ8"};